module.exports = __webpack_public_path__ + "media/images/hello-goodness--oneliner-e033159f854c37f5f59b1601d10e87dc.png";